<template>
<div class="mainMenu">
    <div class="iconwrap">
               <div id="menuIcon" class="icon nav-icon-wdm" @click="openMenu">
                 <span></span>
                 <span></span>
                 <span></span>
                </div>Menu
      </div>
    <img class="logo" src="@/assets/GodEnergi_logo.svg">
    <div v-if="authenticated">
      <nav>
        <router-link to="/">FORSIDE</router-link>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp; 
        <router-link to="/about">OM</router-link>
        <span v-if="isMinAdmin" >&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;<router-link to="/locations">ADMIN</router-link></span>
        <span v-if="isMinReader">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;<router-link to="/maps">Kort</router-link></span>
      </nav>
    </div>
    <div class="azureAuthentication">
        <div style="display:flex;position:absolute;right: 10px;cursor: pointer;">
            <div class="personWrapper" @click="loginout">
              <img class="person" src="@/assets/person.svg" id="profilePhoto">
              <div v-if="authenticated" class="login">{{ currentUserName }}<br>{{ currentUser}}</div>
              <div v-else class="login">Login</div>
          </div>
      </div>  
    </div>
    <div class="azureAuthentication azureAuthenticationSimpel">
        <div style="display:flex;position:absolute;right: 10px;cursor: pointer;">
            <div class="personWrapper" @click="loginout">
              <img class="person" src="@/assets/person.svg" id="profilePhoto">
              <div v-if="authenticated" class="login">{{ currentUserName.split(' ')[0] }}</div>
              <div v-else class="login">Login</div>
          </div>
      </div>  
    </div>
    <div class="burgermenuwrap">
        <div class="burgermenu" :class="[burgermenu ? 'burgermenuopen' : '']">
           <br>
           <router-link @click="openMenu" to="/">FORSIDE</router-link><br>
           <router-link @click="openMenu" to="/about">OM</router-link><br>
            <span v-if="isMinAdmin" > <router-link @click="openMenu" to="/locations">ADMIN</router-link><br></span>
            <span v-if="isMinReader"> <router-link @click="openMenu" to="/maps">Kort</router-link><br></span>
            
            <div class="personMenuWrapper" @click="loginout(); openMenu()">
              <div><img class="person" src="@/assets/person.svg" id="profilePhotoMenu"></div>
              <div v-if="authenticated" class="login">{{ currentUserName }}<br>{{ currentUser}}</div>
              <div v-else class="login">Login</div>
          </div>
        </div>
    </div>

    <div v-if="showVersion" class="systemVersion">System: {{wdm.system }} - ver.{{wdm.version }} - {{ roles }}</div>
</div>

</template>
  
<script>

export default {
  name: 'mainMenu',
  inject:[ 'wdm'],
  emits: ['login', 'logout'],
  props: { 
      currentUser: { type: String, default: ''},
      currentUserName: { type: String, default: ''},
      authenticated: { type: Boolean, default: false},
      roles: Object,
      },
  
  data() { return {  
          burgermenu: false,
          showVersion:  false, 
          loggedIn: false, 
          isMinReader:false, 
          isMinEditor:false, 
          isMinAdmin:false 
        }},
  created() { this.showVersion = !(this.wdm.system == 'PROD')  
  this.loggedIn = this.wdm.loggedIn},
  updated() { 
    this.loggedIn = this.wdm.loggedIn ; 
    if (this.roles.includes('godServiceReader')) {this.isMinReader=true}
    if (this.roles.includes('godServiceEditor'))   {this.isMinReader=true; this.isMinEditor=true}
    if (this.roles.includes('godServiceAdmin'))  {this.isMinReader=true; this.isMinEditor=true; this.isMinAdmin=true }
  },
  methods : {
    openMenu() {
       const menuIcon = document.getElementById('menuIcon')
       menuIcon.classList.toggle("open")
       this.burgermenu = !this.burgermenu
    },
    loginout() {
      if (this.authenticated) {
        this.$emit('logout') 
      } else {
        this.$emit('login') 
      }
    }
  }
}

</script>

<style scoped>
.azureAuthenticationSimpel {

  display: none;

}
.personMenuWrapper {
  margin-top: 50px;
  display: flex;
  position: relative;
  cursor: pointer;
}
.nav-icon-wdm{
  width: 25px;
  height: 20px;
  margin-top: 30px;
  margin-left: 30px;
  margin-right: 30px;
  position: relative;
  cursor: pointer;
  display: inline-block;
}
.nav-icon-wdm span{
  background-color:black;
  position: absolute;
  border-radius: 2px;
  transition: .3s cubic-bezier(.8, .5, .2, 1.4);
  width:100%;
  height: 2px;
}
.nav-icon-wdm span:nth-child(1){
  top:0px;
  left: 0px;
}
.nav-icon-wdm span:nth-child(2){
  top:9px;
  left: 0px;
}
.nav-icon-wdm span:nth-child(3){
  bottom:0px;
  left: 0px;
}

.nav-icon-wdm:not(.open):hover span:nth-child(1){
  transform: scaleX(.9);
}
.nav-icon-wdm:not(.open):hover span:nth-child(2){
  transform: scaleX(.6);
}
.nav-icon-wdm:not(.open):hover span:nth-child(3){
  transform: scaleX(.9);
}

.nav-icon-wdm.open span:nth-child(1){
  transform: rotate(45deg);
  top: 13px;
}
.nav-icon-wdm.open span:nth-child(2){
  opacity:0;
}
.nav-icon-wdm.open span:nth-child(3){
  transform: rotate(-45deg);
  top: 13px;
}


.navbar .iconwrap {
  display: none;
  

}




.logo {
  margin-top: 30px;
  height: 50px;
  
}


.mainMenu {
    background-color: #81B532;
    width: 100%;
    height: 110px;
    color: white;
    margin: 0px;
}

.systemVersion {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 10px;
  font-family: 'Courier New', Courier, monospace;
  color: black;
}
.azureAuthentication {
    position: absolute;
    right: 10px;
    top: 10px;
    height: 90px;
    width: 100px;
    border:0px solid black;
}

nav {
  padding: 40px;
}

nav a {
  font-size: 20px;
  font-weight: bold;
  color: white;
}

nav a.router-link-exact-active {
  color: white;
}

nav a:hover {
    color: grey;
}

.burgermenu {
  z-index: 100;
  text-align: left;
  position: fixed;
  background: transparent;
  height: calc(100% - 90px);
  width: 250px;
  border: 1px solid black;
  left: -300px;
  top: 90px;
  transition: all .5s ease-out;
  padding-left: 10px;
  line-height: 1.95;
  
}
.burgermenu a {
  text-decoration: none;
  color: black;
  padding-left: 10px;
  
}


.burgermenu a:hover {
  
  border-left: 3px solid;
  padding-left: 7px;
  border-color: var(--nomeco-green);

}

.burgermenuopen {
  left: 0px;
  background:  var(--godenergi-green );
  
}



.person {
    width:50px;
    border-radius: 50%;
}

.login {
    color: black;
    line-height: 16px;
    font-size: 14px;
    margin: 5px;
    width: auto;
    white-space: nowrap;
}

@media screen and (max-width:1000px) {
  .logo {
  height: 40px;
}
.person {
    width:40px;
    
}
.login {
  font-size: 15px;
}

}

@media screen and (max-width:800px) {
  .logo {
  margin-top:35px;
  height: 30px;
}
.person {
    width:30px;
    
}
.login {
  font-size: 12px;
}
nav {
  padding: 40px;
}
nav a {
  font-size: 15px;
  font-weight: normal; 
}
.mainMenu {
    height: 90px;
    
}

}

.iconwrap {
  align-items: center;
  height: 80px;
  width: 99px;
  color: black;
  text-align: center;
  display: none;
  }

@media screen and (max-width:650px) {
  .mainMenu { display: flex; }
  .logo { 
    margin-left: 80px;
    margin-right: auto;

    }
  nav {display: none}
  div.iconwrap { display:block}

  div.azureAuthentication {display: none}
  div.azureAuthenticationSimpel { margin-top: 10px; display: block}
}

</style>